
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	aguardando: false,
	modoTela: 'lista',
	lista: [],
	listaMedia: [],
	listaRota: [],
	listaConsulta: [],
	listaPeso: [
		{ id: 1, peso_inicial: 0, peso_final: 1999 },
		{ id: 2, peso_inicial: 2000, peso_final: 3999 },
		{ id: 3, peso_inicial: 4000, peso_final: 5999 },
		{ id: 4, peso_inicial: 6000, peso_final: 7999 },
		{ id: 5, peso_inicial: 8000, peso_final: 9999 },
		{ id: 6, peso_inicial: 10000, peso_final: 11999 },
		{ id: 7, peso_inicial: 12000, peso_final: 13999 },
		{ id: 8, peso_inicial: 14000, peso_final: 15999 },
		{ id: 9, peso_inicial: 16000, peso_final: 17999 },
		{ id: 10, peso_inicial: 18000, peso_final: 19999 },
		{ id: 11, peso_inicial: 20000, peso_final: 21999 },
		{ id: 12, peso_inicial: 22000, peso_final: 23999 },
		{ id: 13, peso_inicial: 24000, peso_final: 25999 },
		{ id: 14, peso_inicial: 26000, peso_final: 27999 },
		{ id: 15, peso_inicial: 28000, peso_final: 29999 },
		{ id: 16, peso_inicial: 30000, peso_final: 31999 },
		{ id: 17, peso_inicial: 32000, peso_final: 33999 },
		{ id: 18, peso_inicial: 34000, peso_final: 35999 },
		{ id: 19, peso_inicial: 36000, peso_final: 37999 },
		{ id: 20, peso_inicial: 38000, peso_final: 39999 },
		{ id: 21, peso_inicial: 40000, peso_final: 44999 },
		{ id: 22, peso_inicial: 45000, peso_final: 49999 },
		{ id: 23, peso_inicial: 50000, peso_final: 54999 },
		{ id: 24, peso_inicial: 55000, peso_final: 59999 }
	],
	filtro: {

	},
	listaLog: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'META_COMBUSTIVEL_MODELO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'META_COMBUSTIVEL_MODELO_FILTRO':
            return { ...state,
				filtro: action.payload.filtro
			};

		case 'META_COMBUSTIVEL_MODELO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

        case 'META_COMBUSTIVEL_MODELO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'META_COMBUSTIVEL_MODELO_CONSULTA_LISTADO':
			return {
				...state,
				listaConsulta: action.payload.data
			};

		case 'META_COMBUSTIVEL_MODELO_CONSULTA_LOG_LISTADO':
			return {
				...state,
				listaLog: action.payload.data
			};

		case 'META_COMBUSTIVEL_MODELO_MEDIA_LISTADO':
            return {
				...state,
				listaMedia: action.payload.data
			};
		
		case 'META_COMBUSTIVEL_MODELO_ROTA_LISTADO':
            return {
				...state,
				listaRota: action.payload.data
			};

        default:
            return state;
    }
}
